__webpack_require__.p = "https://product-gallery-4all.cloudinary.com/";